import script from "./yhqGrantList.vue?vue&type=script&setup=true&lang=js"
export * from "./yhqGrantList.vue?vue&type=script&setup=true&lang=js"

import "./yhqGrantList.vue?vue&type=style&index=0&id=300c15a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-300c15a0"]])

export default __exports__